export const ITEM_HEIGHT = 36;
/**
 * Minimum row height for the mobile drill-down tree — a floor, not a fixed height.
 * Long BIM names wrap freely and grow the row past it; nothing virtualises on this value.
 */
export const ITEM_HEIGHT_IOS = 68;
/** Mobile row spacing from the Figma layout. */
export const MOBILE_ROW_ICON_TO_LABEL_GAP = 10;
export const MOBILE_ROW_LABEL_TO_TOGGLE_GAP = 8;
/** Best-guess until design confirms badge↔pill spacing (matches label→toggle). */
export const MOBILE_ROW_BADGE_TO_TOGGLE_GAP = 8;
export const MOBILE_ROW_TOGGLE_TO_CHEVRON_GAP = 12;
export const ROW_PADDING_LEFT = 16;
export const CHECKBOX_WIDTH = 32;
export const CHEVRON_SIZE = 24;
export const LEVEL_INDENT_BASE = 24;
export const LEVEL_INDENT_INCREMENT = 32;
export const CLICK_DELAY = 200;
/**
 * Trailing auto-generated index suffix that search-db appends to disambiguate
 * sibling objects, e.g. the " (69)" in "Upholstery Arms (69)". Capture group 1
 * is the clean base name. Parentheses are required so legitimate trailing
 * numbers (e.g. "Level 1", "Grid 100") are preserved.
 */
export const INDEX_SUFFIX_PATTERN = /^(.+?)\s+\(\d+\)$/;
